import React, { Component } from "react";
import ToGIFWorkContentVideoRender from "./children/ToGIFWorkContentWorkRender";
import sentGAEvent from "@/ga";
import "@/assets/toGIF.less";

class ToGIFWorkContentVideoFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      framesRate: 10,
      fps: 30,
      resolution: "360:-1",
      width: 0,
      height: "AUTO",
    };
  }

  handleStartChange = e => {
    const value = e.target.value;
    const toGifObj = { ...this.props.toGifObj };
    toGifObj.start = value;
    this.props.onToGifObjChange(toGifObj);
  };

  handleEndChange = e => {
    console.log(e.target.value);
    const value = e.target.value;
    const toGifObj = { ...this.props.toGifObj };
    toGifObj.end = value;
    this.props.onToGifObjChange(toGifObj);
  };

  handleRateChange = value => {
    this.setState({ framesRate: value });
    const toGifObj = { ...this.props.toGifObj };
    toGifObj.framesRate = value;
    this.props.onToGifObjChange(toGifObj);
  };

  handleResolutionChange = value => {
    this.setState({ resolution: value });
    const toGifObj = { ...this.props.toGifObj };
    toGifObj.resolution = value;
    this.props.onToGifObjChange(toGifObj);
  };

  handleWidthChange = e => {
    let value = e.target.value;
    if (!/^[1-9]\d*$|^$/.test(value)) {
      return false;
    }
    if (value) {
      value = parseInt(value);
      const video = document.querySelector(".videoWrap video");
      if (value >= video.videoWidth) {
        value = video.videoWidth;
      }
    }
    const toGifObj = { ...this.props.toGifObj };
    toGifObj.width = value;
    toGifObj.height = "AUTO";
    this.props.onToGifObjChange(toGifObj);
  };

  handleHeightChange = e => {
    let value = e.target.value;
    if (!/^[1-9]\d*$|^$/.test(value)) {
      return false;
    }
    if (value) {
      value = parseInt(value);
      const video = document.querySelector(".videoWrap video");
      if (value >= video.videoHeight) {
        value = video.videoHeight;
      }
    }
    const toGifObj = { ...this.props.toGifObj };
    toGifObj.height = value;
    toGifObj.width = "AUTO";
    this.props.onToGifObjChange(toGifObj);
  };

  handleHeightFocus = () => {
    const toGifObj = { ...this.props.toGifObj };
    if (toGifObj.height === "AUTO") {
      toGifObj.height = "";
    }
    this.props.onToGifObjChange(toGifObj);
  };

  handleWidthFocus = () => {
    const toGifObj = { ...this.props.toGifObj };
    if (toGifObj.width === "AUTO") {
      toGifObj.width = "";
    }
    this.props.onToGifObjChange(toGifObj);
  };

  handleWidthBlur = () => {
    sentGAEvent({
      category: "ToGif",
      action: "GifCustom",
    });
    const toGifObj = { ...this.props.toGifObj };
    if (toGifObj.width === "") {
      toGifObj.width = toGifObj.height === "AUTO" ? document.querySelector(".videoWrap video").videoWidth : "AUTO";
    } else if (toGifObj.width < 100) {
      toGifObj.width = 100;
    }
    this.props.onToGifObjChange(toGifObj);
  };

  handleHeightBlur = () => {
    sentGAEvent({
      category: "ToGif",
      action: "GifCustom",
    });
    const toGifObj = { ...this.props.toGifObj };
    if (toGifObj.height === "") {
      toGifObj.height = toGifObj.width === "AUTO" ? document.querySelector(".videoWrap video").videoHeight : "AUTO";
    } else if (toGifObj.height < 100) {
      toGifObj.height = 100;
    }
    this.props.onToGifObjChange(toGifObj);
  };

  componentDidMount() {
    if (this.props.toGifObj) {
      this.setState({
        fps: this.props.toGifObj.fps,
        framesRate: this.props.toGifObj.fps,
      });
      const toGifObj = { ...this.props.toGifObj };
      toGifObj.resolution = this.state.resolution;
      toGifObj.framesRate = this.props.toGifObj.fps ? this.props.toGifObj.fps : this.state.framesRate;
      this.props.onToGifObjChange(toGifObj);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.toGifObj) {
      if (this.props.toGifObj.fps && prevState.fps !== this.props.toGifObj.fps) {
        this.setState({
          fps: this.props.toGifObj.fps,
          framesRate: this.props.toGifObj.fps,
        });
      }
    }
  }

  render() {
    return (
      <ToGIFWorkContentVideoRender
        toGifObj={this.props.toGifObj}
        fps={this.state.fps}
        framesRate={this.state.framesRate}
        resolution={this.state.resolution}
        width={this.props.toGifObj.width}
        height={this.props.toGifObj.height}
        handleRateChange={this.handleRateChange}
        handleResolutionChange={this.handleResolutionChange}
        handleStartChange={this.handleStartChange}
        handleEndChange={this.handleEndChange}
        handleWidthChange={this.handleWidthChange}
        handleHeightChange={this.handleHeightChange}
        handleHeightFocus={this.handleHeightFocus}
        handleWidthFocus={this.handleWidthFocus}
        handleWidthBlur={this.handleWidthBlur}
        handleHeightBlur={this.handleHeightBlur}
      />
    );
  }
}

export default ToGIFWorkContentVideoFunction;
